import { useCallback } from "react";
import { usePlaylistEdit } from "frontend/src/domain/playlists";
import { playPlaylistAttempted } from "frontend/src/features/play-playlist";
import { pause, resume } from "frontend/src/features/control-audio";
export var usePlaylist = function (initial) {
    var playlist = usePlaylistEdit(initial);
    var change = {
        title: function (evt) {
            return playlist.title.set(evt.target.value);
        },
        client: function (client) { var _a; return playlist.clientId.set((_a = client === null || client === void 0 ? void 0 : client.id) !== null && _a !== void 0 ? _a : null); },
        published: function (evt) {
            return playlist.published.set(evt.target.checked);
        },
        businessTypes: function (object) {
            return playlist.businessTypes.set(object.checked
                ? playlist.businessTypes.value.concat(object.id)
                : playlist.businessTypes.value.filter(function (itemId) { return itemId !== object.id; }));
        },
    };
    var update = function (evt) {
        evt.preventDefault();
        playlist.update.run();
    };
    var play = useCallback(function (_a) {
        var selected = _a.selected, index = _a.index;
        if (!selected) {
            playPlaylistAttempted({
                id: initial.id,
                title: playlist.title.value,
                startAtTrackIndex: index,
                tracks: playlist.entries.tracks,
            });
        }
        else {
            resume();
        }
    }, [playlist.entries.tracks, playlist.title.value, initial.id]);
    return {
        title: {
            value: playlist.title.value,
            error: playlist.title.error.message,
            onChange: change.title,
        },
        entries: playlist.entries,
        published: {
            value: playlist.published.value,
            onChange: change.published,
        },
        clientId: { value: playlist.clientId.value, onChange: change.client },
        type: { value: playlist.type.value, onChange: playlist.type.set },
        businessTypes: {
            value: playlist.businessTypes.value,
            onChange: change.businessTypes,
        },
        image: playlist.image,
        actions: {
            play: play,
            pause: pause,
            update: {
                run: update,
                pending: playlist.update.pending,
            },
        },
    };
};
